import React from 'react'

import { InputGroup, Checkbox, DropdownGroup, Flex } from '@clear/design-system'
import { CountryOption } from '@api/getCountries'
import {
  BiographicSearchKeys,
  BiographicSearchLabels,
} from '@validators/schema/shared/biographicSearchSchema'
import { handleDataChange } from '@utils/handleDateChange'
import useSuffixOptions from '@hooks/useSuffixOptions'
import prependBlankOption from '@utils/prependBlankOption'

function BiographicsStatusSearchView({
  register,
  noMiddleName,
  countries,
  firstNameErrorMessage,
  middleNameErrorMessage,
  lastNameErrorMessage,
  dobErrorMessage,
  countryOfBirthErrorMessage,
  setValue,
  showSuffix,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  register: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: any
  noMiddleName: boolean
  countries: CountryOption[]
  firstNameErrorMessage?: string
  middleNameErrorMessage?: string
  lastNameErrorMessage?: string
  dobErrorMessage?: string
  countryOfBirthErrorMessage?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setValue: any
  showSuffix?: boolean
}) {
  const [suffixes, isSuffixesLoading] = useSuffixOptions()
  return (
    <Flex flexDirection="column">
      <InputGroup
        {...register(BiographicSearchKeys.FIRST_NAME)}
        id={BiographicSearchKeys.FIRST_NAME}
        data-cy={BiographicSearchKeys.FIRST_NAME}
        name={BiographicSearchKeys.FIRST_NAME}
        label={BiographicSearchLabels.firstName}
        error={firstNameErrorMessage}
      />
      <InputGroup
        {...register(BiographicSearchKeys.MIDDLE_NAME)}
        id={BiographicSearchKeys.MIDDLE_NAME}
        data-cy={BiographicSearchKeys.MIDDLE_NAME}
        name={BiographicSearchKeys.MIDDLE_NAME}
        label={BiographicSearchLabels.middleName}
        disabled={noMiddleName}
        error={middleNameErrorMessage}
      />
      <Checkbox
        {...register(BiographicSearchKeys.NO_MIDDLE_NAME)}
        id={BiographicSearchKeys.NO_MIDDLE_NAME}
        data-cy={BiographicSearchKeys.NO_MIDDLE_NAME}
        name={BiographicSearchKeys.NO_MIDDLE_NAME}
        text={BiographicSearchLabels.noMiddleName}
        flexShrink={0}
        flexGrow={0}
      />
      <InputGroup
        {...register(BiographicSearchKeys.LAST_NAME)}
        id={BiographicSearchKeys.LAST_NAME}
        data-cy={BiographicSearchKeys.LAST_NAME}
        name={BiographicSearchKeys.LAST_NAME}
        label={BiographicSearchLabels.lastName}
        error={lastNameErrorMessage}
      />
      <InputGroup
        data-cy="dateOfBirth"
        label="Date of Birth"
        placeholder="mm/dd/yyyy"
        {...register(BiographicSearchKeys.DOB)}
        onChange={(e) =>
          handleDataChange(e, setValue, BiographicSearchKeys.DOB)
        }
        error={dobErrorMessage}
      />

      <DropdownGroup
        {...register(BiographicSearchKeys.COUNTRY_OF_BIRTH)}
        id={BiographicSearchKeys.COUNTRY_OF_BIRTH}
        name={BiographicSearchKeys.COUNTRY_OF_BIRTH}
        data-cy={BiographicSearchKeys.COUNTRY_OF_BIRTH}
        label={BiographicSearchLabels.countryOfBirth}
        options={prependBlankOption(countries)}
        error={countryOfBirthErrorMessage}
      />
      {showSuffix && (
        <DropdownGroup
          label="Suffix (Optional)"
          data-cy={BiographicSearchKeys.SUFFIX}
          options={prependBlankOption(suffixes)}
          disabled={isSuffixesLoading}
          {...register('suffix')}
          autoComplete="honorific-suffix"
        />
      )}
    </Flex>
  )
}

export default BiographicsStatusSearchView
